var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.642 4.807 C 11.280 4.911,10.907 5.291,10.805 5.661 C 10.580 6.468,11.246 7.288,12.080 7.230 C 12.716 7.186,13.240 6.630,13.240 6.000 C 13.240 5.203,12.413 4.585,11.642 4.807 M11.642 10.807 C 11.280 10.911,10.907 11.291,10.805 11.661 C 10.580 12.468,11.246 13.288,12.080 13.230 C 12.716 13.186,13.240 12.630,13.240 12.000 C 13.240 11.203,12.413 10.585,11.642 10.807 M11.642 16.807 C 11.280 16.911,10.907 17.291,10.805 17.661 C 10.580 18.468,11.246 19.288,12.080 19.230 C 12.716 19.186,13.240 18.630,13.240 18.000 C 13.240 17.203,12.413 16.585,11.642 16.807 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.0ce96fb3.svg";
export { ForwardRef as ReactComponent };